import Component from "../abstracts/Component";

export default class CheckboxIconComponent extends Component {
  get SELECTORS() {
    return {
      input: '.form-check-input',
      label: '.form-check-label',
    };
  }

  get COMPONENTNAME() {
    return "CheckboxIconComponent";
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.input = this.$component.querySelector(this.SELECTORS.input);
    this.label = this.$component.querySelector(this.SELECTORS.label);
  }

  bindEvents() {
    const ctx = this;
    this.label.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        ctx.input.click();
      }
    });
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
  }
}
